var _circle, _g, _g2, _path, _path2, _path3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    opacity: 0.98
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 82,
    cy: 82,
    r: 82,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5315",
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.66
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Receipt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M135.574 52.4797V63.0631C135.574 69.973 131.201 74.3463 124.291 74.3463H109.334V43.7767C109.334 38.9223 113.314 34.9863 118.168 34.9863C122.935 35.0301 127.308 36.9543 130.457 40.1031C133.606 43.2957 135.574 47.669 135.574 52.4797Z",
    fill: "white",
    stroke: "#888888",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.1074 56.853V118.08C48.1074 121.71 52.2184 123.765 55.1048 121.578L62.5832 115.98C64.3325 114.668 66.7816 114.843 68.356 116.418L75.6157 123.721C77.3213 125.427 80.1202 125.427 81.8258 123.721L89.173 116.374C90.7037 114.843 93.1528 114.668 94.8584 115.98L102.337 121.578C105.223 123.721 109.334 121.666 109.334 118.08V43.733C109.334 38.9223 113.27 34.9863 118.081 34.9863H69.9741H65.6008C52.4808 34.9863 48.1074 42.8146 48.1074 52.4797V56.853Z",
    fill: "white",
    stroke: "#888888",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M78.7207 99.5371H91.8407",
    stroke: "#D9D9D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M78.7207 82.042H91.8407",
    stroke: "#D9D9D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5811 99.4922H65.6203H65.5811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5811 99.4922H65.6203",
    stroke: "#D9D9D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5811 82H65.6203H65.5811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5811 82H65.6203",
    stroke: "#D9D9D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "$",
    d: "M87.0274 70.2215V40.4033H88.9376V70.2215H87.0274ZM92.0941 50.2457C92.001 49.3061 91.6011 48.5761 90.8944 48.0559C90.1878 47.5356 89.2288 47.2755 88.0174 47.2755C87.1943 47.2755 86.4993 47.392 85.9325 47.6249C85.3656 47.8501 84.9308 48.1646 84.6279 48.5684C84.3329 48.9722 84.1853 49.4303 84.1853 49.9428C84.1698 50.3699 84.2591 50.7426 84.4532 51.061C84.6551 51.3794 84.9308 51.655 85.2802 51.888C85.6297 52.1132 86.0334 52.3112 86.4916 52.482C86.9497 52.6451 87.4389 52.7849 87.9592 52.9013L90.1024 53.4138C91.1429 53.6468 92.098 53.9574 92.9677 54.3457C93.8374 54.7339 94.5906 55.2115 95.2274 55.7783C95.8641 56.3452 96.3572 57.013 96.7066 57.7817C97.0638 58.5505 97.2463 59.4318 97.2541 60.4258C97.2463 61.8856 96.8736 63.1513 96.1359 64.2229C95.406 65.2868 94.3499 66.1137 92.9677 66.7039C91.5933 67.2863 89.9354 67.5775 87.9941 67.5775C86.0684 67.5775 84.3911 67.2824 82.9623 66.6922C81.5413 66.1021 80.4309 65.2285 79.6311 64.0715C78.839 62.9067 78.4236 61.4663 78.3848 59.7502H83.2652C83.3195 60.55 83.5486 61.2178 83.9524 61.7536C84.3639 62.2816 84.9114 62.6815 85.5947 62.9533C86.2858 63.2173 87.0662 63.3493 87.9359 63.3493C88.7901 63.3493 89.5316 63.2251 90.1606 62.9766C90.7974 62.7281 91.2904 62.3826 91.6399 61.94C91.9893 61.4974 92.164 60.9887 92.164 60.4141C92.164 59.8783 92.0048 59.4279 91.6865 59.063C91.3759 58.698 90.9177 58.3874 90.312 58.1312C89.7141 57.8749 88.9803 57.642 88.1106 57.4323L85.5132 56.78C83.502 56.2908 81.914 55.526 80.7493 54.4854C79.5845 53.4449 79.006 52.0433 79.0137 50.2806C79.006 48.8363 79.3904 47.5744 80.1669 46.4951C80.9511 45.4157 82.0266 44.5732 83.3933 43.9675C84.76 43.3618 86.313 43.059 88.0524 43.059C89.8228 43.059 91.3681 43.3618 92.6882 43.9675C94.016 44.5732 95.0488 45.4157 95.7865 46.4951C96.5242 47.5744 96.9047 48.8246 96.9279 50.2457H92.0941Z",
    fill: "#4A154B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 5099"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 184",
    cx: 113.161,
    cy: 40.9996,
    r: 16.4,
    fill: "#F25E4A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.565 34.4035C106.845 34.1233 107.299 34.1233 107.579 34.4035L119.756 46.5799C120.036 46.8601 120.036 47.3144 119.756 47.5946C119.476 47.8748 119.021 47.8748 118.741 47.5946L106.565 35.4182C106.284 35.138 106.284 34.6837 106.565 34.4035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.756 34.4035C120.036 34.6837 120.036 35.138 119.756 35.4182L107.579 47.5946C107.299 47.8748 106.845 47.8748 106.565 47.5946C106.285 47.3144 106.285 46.8601 106.565 46.5799L118.741 34.4035C119.021 34.1233 119.476 34.1233 119.756 34.4035Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "card",
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.2474 88.5605H62.489C71.5386 88.5605 73.8009 90.7691 73.8009 99.5781V120.183C73.8009 128.992 71.5386 131.2 62.5145 131.2H34.2474C25.2233 131.225 22.9609 129.017 22.9609 120.208V99.5781C22.9609 90.7691 25.2233 88.5605 34.2474 88.5605Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.2393 101.483H70.521",
    stroke: "#888888",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M25.4209 121.36L53.3009 121.36",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2905 113.226C27.9395 113.226 27.6405 113.13 27.3936 112.939C27.1467 112.746 26.958 112.468 26.8275 112.103C26.6971 111.736 26.6318 111.294 26.6318 110.775C26.6318 110.259 26.6971 109.819 26.8275 109.454C26.9595 109.088 27.149 108.808 27.3959 108.615C27.6444 108.421 27.9426 108.324 28.2905 108.324C28.6384 108.324 28.9358 108.421 29.1827 108.615C29.4312 108.808 29.6206 109.088 29.7511 109.454C29.8831 109.819 29.9491 110.259 29.9491 110.775C29.9491 111.294 29.8839 111.736 29.7534 112.103C29.623 112.468 29.4343 112.746 29.1873 112.939C28.9404 113.13 28.6415 113.226 28.2905 113.226ZM28.2905 112.713C28.6384 112.713 28.9086 112.545 29.1012 112.21C29.2937 111.874 29.39 111.396 29.39 110.775C29.39 110.362 29.3458 110.01 29.2572 109.72C29.1703 109.429 29.0445 109.208 28.8798 109.056C28.7168 108.903 28.5203 108.827 28.2905 108.827C27.9457 108.827 27.6762 108.997 27.4821 109.338C27.288 109.676 27.1909 110.155 27.1909 110.775C27.1909 111.188 27.2344 111.539 27.3214 111.828C27.4084 112.117 27.5334 112.336 27.6964 112.487C27.8611 112.638 28.0591 112.713 28.2905 112.713Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2105 113.226C32.8595 113.226 32.5605 113.13 32.3136 112.939C32.0667 112.746 31.878 112.468 31.7475 112.103C31.6171 111.736 31.5518 111.294 31.5518 110.775C31.5518 110.259 31.6171 109.819 31.7475 109.454C31.8795 109.088 32.069 108.808 32.3159 108.615C32.5644 108.421 32.8626 108.324 33.2105 108.324C33.5584 108.324 33.8558 108.421 34.1027 108.615C34.3512 108.808 34.5406 109.088 34.6711 109.454C34.8031 109.819 34.8691 110.259 34.8691 110.775C34.8691 111.294 34.8039 111.736 34.6734 112.103C34.543 112.468 34.3543 112.746 34.1073 112.939C33.8604 113.13 33.5615 113.226 33.2105 113.226ZM33.2105 112.713C33.5584 112.713 33.8286 112.545 34.0212 112.21C34.2137 111.874 34.31 111.396 34.31 110.775C34.31 110.362 34.2658 110.01 34.1772 109.72C34.0903 109.429 33.9645 109.208 33.7998 109.056C33.6368 108.903 33.4403 108.827 33.2105 108.827C32.8657 108.827 32.5962 108.997 32.4021 109.338C32.208 109.676 32.1109 110.155 32.1109 110.775C32.1109 111.188 32.1544 111.539 32.2414 111.828C32.3284 112.117 32.4534 112.336 32.6164 112.487C32.7811 112.638 32.9791 112.713 33.2105 112.713Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1305 113.226C37.7795 113.226 37.4805 113.13 37.2336 112.939C36.9867 112.746 36.798 112.468 36.6675 112.103C36.5371 111.736 36.4718 111.294 36.4718 110.775C36.4718 110.259 36.5371 109.819 36.6675 109.454C36.7995 109.088 36.989 108.808 37.2359 108.615C37.4844 108.421 37.7826 108.324 38.1305 108.324C38.4784 108.324 38.7758 108.421 39.0227 108.615C39.2712 108.808 39.4606 109.088 39.5911 109.454C39.7231 109.819 39.7891 110.259 39.7891 110.775C39.7891 111.294 39.7239 111.736 39.5934 112.103C39.463 112.468 39.2743 112.746 39.0273 112.939C38.7804 113.13 38.4815 113.226 38.1305 113.226ZM38.1305 112.713C38.4784 112.713 38.7486 112.545 38.9412 112.21C39.1337 111.874 39.23 111.396 39.23 110.775C39.23 110.362 39.1858 110.01 39.0972 109.72C39.0103 109.429 38.8845 109.208 38.7198 109.056C38.5568 108.903 38.3603 108.827 38.1305 108.827C37.7857 108.827 37.5162 108.997 37.3221 109.338C37.128 109.676 37.0309 110.155 37.0309 110.775C37.0309 111.188 37.0744 111.539 37.1614 111.828C37.2484 112.117 37.3734 112.336 37.5364 112.487C37.7011 112.638 37.8991 112.713 38.1305 112.713Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0505 113.226C42.6995 113.226 42.4005 113.13 42.1536 112.939C41.9067 112.746 41.718 112.468 41.5875 112.103C41.4571 111.736 41.3918 111.294 41.3918 110.775C41.3918 110.259 41.4571 109.819 41.5875 109.454C41.7195 109.088 41.909 108.808 42.1559 108.615C42.4044 108.421 42.7026 108.324 43.0505 108.324C43.3984 108.324 43.6958 108.421 43.9427 108.615C44.1912 108.808 44.3806 109.088 44.5111 109.454C44.6431 109.819 44.7091 110.259 44.7091 110.775C44.7091 111.294 44.6439 111.736 44.5134 112.103C44.383 112.468 44.1943 112.746 43.9473 112.939C43.7004 113.13 43.4015 113.226 43.0505 113.226ZM43.0505 112.713C43.3984 112.713 43.6686 112.545 43.8612 112.21C44.0537 111.874 44.15 111.396 44.15 110.775C44.15 110.362 44.1058 110.01 44.0172 109.72C43.9303 109.429 43.8045 109.208 43.6398 109.056C43.4768 108.903 43.2803 108.827 43.0505 108.827C42.7057 108.827 42.4362 108.997 42.2421 109.338C42.048 109.676 41.9509 110.155 41.9509 110.775C41.9509 111.188 41.9944 111.539 42.0814 111.828C42.1684 112.117 42.2934 112.336 42.4564 112.487C42.6211 112.638 42.8191 112.713 43.0505 112.713Z",
    fill: "#232323"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceEmpty);
export default __webpack_public_path__ + "static/media/invoiceEmpty.2428af6d3ada13653f8e6dd65dfe9f63.svg";
export { ForwardRef as ReactComponent };